module.exports = ".btn-xs{color:#2968ed}\n"